import axios, { type AxiosError, type InternalAxiosRequestConfig } from 'axios';
import { useAuth } from '../store/auth';

const api = axios.create({ baseURL: '/api', timeout: 20000 });

api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = useAuth.getState().accessToken;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshing: Promise<string | null> | null = null;

api.interceptors.response.use(
  (r) => r,
  async (error: AxiosError) => {
    const original = error.config as InternalAxiosRequestConfig & { _retry?: boolean };
    if (error.response?.status === 401 && !original._retry && useAuth.getState().refreshToken) {
      original._retry = true;
      if (!refreshing) {
        const rt = useAuth.getState().refreshToken!;
        refreshing = axios
          .post('/api/auth/refresh', { refreshToken: rt })
          .then((res) => {
            useAuth.getState().setSession(res.data);
            return res.data.accessToken as string;
          })
          .catch(() => { useAuth.getState().clear(); return null; })
          .finally(() => { refreshing = null; });
      }
      const newToken = await refreshing;
      if (newToken) {
        original.headers!.Authorization = `Bearer ${newToken}`;
        return api(original);
      }
    }
    return Promise.reject(error);
  },
);

export default api;
